export default __webpack_public_path__ + "static/media/Xinjiang-Aletai-Huaning-Hydropower-Project-photo_4-1point-5.af1f89b0.jpg";